exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-button[data-v-0d488ad0] {\n  padding: var(--pad);\n  border: 1px solid;\n  border-radius: var(--radius);\n}\n.form-button[data-v-0d488ad0]:disabled {\n  cursor: default;\n  color: var(--tertiary);\n}", ""]);

// exports
